<div class="cultureBreakdown_container">
  <div class="cultureBreakdown_headerContainer">
    <div class="cultureBreakdown_headerTextContainer">
      <span class="cultureBreakdown_cultureNameText">{{ selectedCulture?.name }}</span>
    </div>
    <button
      mat-icon-button
      class="cultureBreakdown_CloseBtn"
      (click)="onCloseClick()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-divider style="padding-bottom: 10px"></mat-divider>
  <app-culture-details-widget
    [selectedCultureId]="selectedCulture?.cultureId ?? ''"
  ></app-culture-details-widget>
  <div class="cultureBreakdown_breakdownHeaderContainer">
    <span class="cultureBreakdown_breakdownHeaderText">{{"stateView.sidenavCultureBreakdown" | translate}}</span>
    <app-claro-tooltip-icon [translatedTooltipText]="'stateView.tooltipTexts.cultureBreakdown' | translate"></app-claro-tooltip-icon>
  </div>
  <app-side-nav-driver-breakdown-list 
  [drivers]="selectedCulture?.driversBreakdown ?? []">
  </app-side-nav-driver-breakdown-list>
</div>
